/*
 * Copyright (c) 2026 NOOGA DEVELOPMENT, All rights reserved.
 * Author Raman Kremko <raman.kremko@noogadev.com>
 */

import apiClient from 'data/api/apiClient';
import {
    CashRegistersListDto,
    CashRegistersListRequestParams,
    CashRegisterDto,
    InitOtpResponseDto,
    CashRegisterStatusHistoryPage,
    CashRegisterStatusHistoryParams,
} from './cashRegistersClient.typings';
import {
    cutEmptyParams,
    cutEmptyParamsIncludingArrays,
    DATA_UNAVAILABLE,
    makeArrayFromCommaSeparatedString,
} from '../../../utils/utils';
import { CashRegistersListTableData } from '../../../components/RegistryWidgets/CashRegisters/CashRegistersList/CashRegistersListConfig';

export const SEARCH_TYPE_TO_SEARCH_PARAM: { [key in keyof CashRegistersListTableData]?: string } = {
    factoryNumber: 'factoryNumber',
    modelName: 'modelName',
};

const getSearchParamName = (searchType: keyof CashRegistersListTableData): string => {
    let searchParam = SEARCH_TYPE_TO_SEARCH_PARAM[searchType];
    if (searchParam === undefined) searchParam = DATA_UNAVAILABLE;
    return searchParam;
};

const adjustCashRegistersListFilterParams = (params: CashRegistersListRequestParams) => {
    const { search_type, search_text } = params;

    delete params.search_text;
    delete params.search_type;

    let queryParams = {
        ...params,
        [getSearchParamName(search_type as keyof CashRegistersListTableData)]: makeArrayFromCommaSeparatedString(
            search_text,
            true,
        ),
    };

    if (search_type === SEARCH_TYPE_TO_SEARCH_PARAM.factoryNumber) {
        queryParams = {
            ...queryParams,
            [getSearchParamName(search_type as keyof CashRegistersListTableData)]: search_text,
        };
    }

    return cutEmptyParamsIncludingArrays(queryParams);
};

async function listCashRegisters(params: CashRegistersListRequestParams): Promise<CashRegistersListDto> {
    return apiClient.get<CashRegistersListDto>('1.0.0/cashRegisters', adjustCashRegistersListFilterParams(params));
}

async function fetchCashRegister(factoryNumber: string): Promise<CashRegisterDto> {
    return apiClient.get<CashRegisterDto>(`1.0.0/cashRegisters/${factoryNumber}`);
}

async function createInitOtp(factoryNumber: string): Promise<InitOtpResponseDto> {
    return apiClient.post<InitOtpResponseDto>(`1.0.0/cashRegisters/${factoryNumber}/init/otp`);
}

async function fetchStatusHistory({
    factoryNumber,
    ...params
}: CashRegisterStatusHistoryParams): Promise<CashRegisterStatusHistoryPage> {
    return apiClient.get<CashRegisterStatusHistoryPage>(
        `1.0.0/cashRegisters/${factoryNumber}/statuses`,
        cutEmptyParams(params),
    );
}

export const cashRegistersClient = {
    listCashRegisters,
    fetchCashRegister,
    createInitOtp,
    fetchStatusHistory,
};
